import { FC, useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { useAuthContext, useDeleteUser, useSubscriptionContext } from '../../../../data-access';
import { DeleteAccountDialog } from '../../../Subscriptions';

import './SubscriptionSettings.scss';

interface AccountActionsProps {
  className?: string;
}

const AccountActions: FC<AccountActionsProps> = ({ className }) => {
  const { t } = useTranslation();
  const { user, signOut } = useAuthContext();
  const { currentSubscription } = useSubscriptionContext();
  const [deleteUserDialogVisible, setDeleteUserDialogVisible] = useState(false);
  const { deleteUser: deleteUserApi, isPending: isDeleting } = useDeleteUser();

  const handleSignOut = () => {
    signOut();
  };

  const handleDeleteUser = async () => {
    if (currentSubscription?.status === 'unsubscribed') {
      if (isDeleting) {
        return;
      }

      await deleteUserApi({ userId: user.userId });
      handleSignOut();
      return;
    }

    setDeleteUserDialogVisible(true);
  };

  return (
    <>
      <div className={clsx('subscription-settings__account', className)}>
        <div onClick={handleSignOut}>{t('settings.subscription.signOut')}</div>
        <div
          onClick={handleDeleteUser}
          className={clsx(
            'subscription-settings__account__delete',
            isDeleting && 'subscription-settings__account__delete--deleting'
          )}
        >
          {isDeleting
            ? t('settings.subscription.deleting')
            : t('settings.subscription.deleteAccount')}
        </div>
      </div>

      <DeleteAccountDialog
        visible={deleteUserDialogVisible}
        where="afterPaywall"
        onClose={() => setDeleteUserDialogVisible(false)}
      />
    </>
  );
};

export default AccountActions;
